export default __webpack_public_path__ + "static/media/cannon-1.57e96352.svg";